import RemiseFinAnneeDetailController from './remise.fin.annee.detail.controller';

export default {
    template: require('./remise.fin.annee.detail.html'),
    controller: RemiseFinAnneeDetailController
};
